import axios from "axios"

export class TinsaAuthService {
  static async validateEmail(valuationId, socialToken, provider, redirectUri) {
    return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
      valuationId: valuationId,
      socialToken: socialToken,
      provider: provider,
      redirectUri: redirectUri,
    })
  }

  static async sendSMSCode(valuationId, phoneNumber) {
    return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
      valuationId: valuationId,
      phoneNumber: phoneNumber,
    })
  }

  static async validateSMSCode(valuationId, phoneNumber, smsCode) {
    return axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/auth/validate-code`,
      {
        valuationId: valuationId,
        phoneNumber: phoneNumber,
        code: smsCode,
      }
    )
  }

  static async setTokenValuation(authToken, valuationId ){
    return axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/enrich-token`,
        {
          valuationId
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
    )
  }
}
